// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__P0+T4","button":"LoginPage_button__b+OTR","form_login":"LoginPage_form_login__-EcVx","wrapper":"LoginPage_wrapper__gjfoB","bg":"LoginPage_bg__FOYKc"};